<script lang="ts" setup>
import type { PropType } from 'vue'
import type { MenuItem } from '@bloomreach/spa-sdk'
import { useHeader } from '../../../composables/useHeader'

defineProps({
    items: {
        type: Array as PropType<MenuItem[]>,
        default: () => [],
    },
})

const { desktopNavActiveIndex } = useHeader()
</script>

<template>
    <nav class="hidden items-center lg:flex">
        <HeaderPartsHeaderLinkDesktop
            v-for="(el, index) in items"
            :key="`desktop-link-${index}`"
            :is-open="index === desktopNavActiveIndex"
            :item="el"
            :index="index"
        />
    </nav>
</template>
